import React from 'react';
import { Button, Descriptions, Modal, Tag } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { formatDate } from '../utils/formatters';

export default function ContactDetailsModal({ open, onCancel, contact, onEdit, t }) {
  if (!contact) return null;

  const tagColor = {
    Email: 'green',
    Phone: 'blue',
    Network: 'cyan',
    'Fair/Event': 'gold',
    Referral: 'purple',
    Other: 'orange',
  }[contact.type] || 'default';

  return (
    <Modal
      title={t('Contact Record Details')}
      open={open}
      onCancel={onCancel}
      footer={[
        <Button key="edit" type="primary" icon={<EditOutlined />} onClick={onEdit}>
          {t('Edit')}
        </Button>,
      ]}
      width={700}
    >
      <Descriptions column={1} bordered>
        <Descriptions.Item label={t('Contact Date')}>{formatDate(contact.date)}</Descriptions.Item>
        <Descriptions.Item label={t('Client & Supplier Name')}>{contact.client}</Descriptions.Item>
        <Descriptions.Item label={t('Contact Source')}>
          <Tag color={tagColor}>{t(contact.type)}</Tag>
        </Descriptions.Item>
        {contact.type === 'Referral' && (
          <Descriptions.Item label={t('Referred by')}>{contact.referredBy || '—'}</Descriptions.Item>
        )}
        {contact.type === 'Fair/Event' && (
          <>
            <Descriptions.Item label={t('Event name')}>{contact.eventName || '—'}</Descriptions.Item>
            <Descriptions.Item label={t('Event date')}>{contact.eventDate ? formatDate(contact.eventDate) : '—'}</Descriptions.Item>
          </>
        )}
        {contact.type === 'Network' && (
          <Descriptions.Item label={t('Network name')}>{contact.networkName || '—'}</Descriptions.Item>
        )}
        <Descriptions.Item label={t('Contact By')}>{contact.userName}</Descriptions.Item>
        <Descriptions.Item label={t('Subject')}>{contact.subject}</Descriptions.Item>
        <Descriptions.Item label={t('Description')}>{contact.description}</Descriptions.Item>
      </Descriptions>
    </Modal>
  );
}
